<template>
  <v-navigation-drawer
    :temporary="temporary"
    touchless
    right
    app
    :mobile-break-point="'mobile-break-point'"
    :clipped="clipped"
    v-model="isShow"
    class="sidedar-content"
    :class="setClassMenu"
    :width="widthSidebar"
    :stateless="stateless"
    :permanent="permanent"
    :fixed="fixed"
    :floating="floating"
    :disable-resize-watcher="'disable-resize-watcher'"
    @input="inputEvent"
    :style="hideScrool"
  >
    <v-toolbar
      class="elevation-1"
      height="50px"
      dark
      color="primary"
      clipped-left
      v-if="toolbar"
      >

      <v-btn icon data-cy="close" class="btn-close" @click.native="closing" dark>
        <v-icon>close</v-icon>
      </v-btn>
      <h2 data-cy="sidebar-content-title">{{title}}</h2>
    </v-toolbar>
    <v-container grid-list-xs class="my-0 pb-0">
      <v-form v-model="valid" ref="form" lazy-validation>
        <!-- <v-layout row wrap v-resize="onResize" :style="checkAutoHeight"> -->
        <v-layout row wrap :style="checkAutoHeight">
          <slot></slot>
        </v-layout>
        <div class="text-xs-right">
          <v-btn
            @click="submit"
            :disabled="!valid"
            :loading="isLoading"
            color="accent"
            v-if="!hideSubmit"
            data-cy="submit"
            >
            {{submitLabel}}
          </v-btn>
        </div>
      </v-form>
    </v-container>
</v-navigation-drawer>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      require: true,
      default: false
    },
    // title: {
    //   type: String,
    //   require: true
    // },
    submitLabel: {
      type: String,
      default: 'Salvar'
    },
    hideSubmit: {
      type: Boolean,
      default: false
    },
    temporary: {
      type: Boolean,
      default: true
    },
    clipped: {
      type: Boolean,
      default: false
    },
    width: {
      type: [ Number, String ]
    },
    hasMenu: {
      type: Boolean,
      default: false
    },
    toolbar: {
      type: Boolean,
      default: true
    },
    stateless: {
      type: Boolean,
      default: false
    },
    'hide-overlay': {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: true
    },
    floating: {
      type: Boolean,
      default: true
    },
    permanent: {
      type: Boolean,
      default: true
    },
    'mobile-break-point': {
      type: [Number, String],
      default: 1264
    },
    'disable-resize-watcher': {
      type: Boolean,
      default: false
    },
    'mini-variant-width': {
      type: [Number, String],
      default: 80
    },
    titleContent: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    drawer: true,
    drawerRight: true,
    right: null,
    valid: true,
    isDisabled: false,
    isShow: false
  }),
  methods: {
    closing () {
      this.isShow = false
      this.$emit('close')
    },
    opening () {
      this.isShow = true
    },
    submit () {
      if (this.$refs.form.validate()) {
        this.$emit('submit')
      }
    },
    inputEvent (status) {
      this.$emit('input', status)
      !status && this.$emit('close')
    },
    actionsKey (event) {
      switch (event.srcKey) {
        case 'closing':
          this.closing()
          console.log('closing')
          break
        case 'opening':
          this.opening()
          console.log('opening')
          break
      }
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    },
    isMobile () {
      return this.$vuetify.breakpoint.xsOnly
    },
    widthSidebar () {
      const innerWidth = window.innerWidth

      if (typeof (this.width) !== 'undefined') {
        return parseInt(this.width) + this.miniVariantWidth
      } else {
        return this.isMobile ? innerWidth : (innerWidth * 50) / 100
      }
    },
    setClassMenu () {
      return this.hasMenu ? 'has-menu' : ''
    },
    checkAutoHeight () {
      return this.hasMenu ? '' : this.setHeightScroll
    },
    hideScrool () {
      // return this.hasMenu ? '' : 'overflow: hidden;'
      return ''
    },
    hasTitle () {
      return this.titleContent !== ''
    },
    title () {
      return this.$route.meta.title
    }
  },
  watch: {
    open (val) {
      this.isShow = val
      this.$nextTick(() => {
        val ? this.$emit('opened') : this.$emit('close')
      })
    }
  },
  mounted () {
    this.isShow = this.open
  },
  beforeDestroy () {
    this.isShow = false
  }
}
</script>

